import React from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
// import {

// } from '@material-ui/core';

function FormikSelect(props) {
  const { label, data, ...rest } = props;
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  return (
    <>
     {/* <FormControl {...rest} error={isError}> */}
      <InputLabel id="label">{label}</InputLabel>
      <Select  {...rest} labelId="label" {...field} value={selectedValue ? selectedValue : ''}>
        {data.map((item, index) => (
          <MenuItem key={index} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
       {/* {_renderHelperText()}
     </FormControl> */}
    </>
  );
}

export default FormikSelect;
